import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, defaultDSCRField, defaultPercentField } from "helpers/row-logic-helper";

import { shouldShowFloatingIndex, shouldShowIoPeriods } from "../deal-settings-rows-logic";

const DEFAULT_WIDTH = 138;

export const underwritingRows = {
  dateOfAction: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Date Of Action", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.DATE, map: data => defaultField(data, "loanProceedAssumptions[0].dateOfAction"), Cell: tableSideColumnMapper }
    ]
  },
  action: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Action", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultField(data, "loanProceedAssumptions[0].action"), Cell: tableSideColumnMapper }
    ]
  },
  loanType: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Loan Type", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultField(data, "loanProceedAssumptions[0].loanTypeRef.name"), Cell: tableSideColumnMapper }
    ]
  },
  term: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Term (Months)", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultField(data, "loanProceedAssumptions[0].term"), Cell: tableSideColumnMapper }
    ]
  },
  amortization: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Amortization Term (Months)", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultField(data, "loanProceedAssumptions[0].amortization"), Cell: tableSideColumnMapper }
    ]
  },
  loanSpread: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Loan Spread", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.PERCENT, map: data => defaultPercentField(data, "loanProceedAssumptions[0].loanSpread", 100), Cell: tableSideColumnMapper, decimals: 3 }
    ]
  },
  rateTypeId: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Rate Type", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultField(data, "loanProceedAssumptions[0].rateType.name"), Cell: tableSideColumnMapper }
    ]
  },
  indexId: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Index", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultField(data, "loanProceedAssumptions[0].index.name"), Cell: tableSideColumnMapper }
    ]
  },
  minDSCR: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Min DSCR", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultDSCRField(data, "loanProceedAssumptions[0].minDSCR"), Cell: tableSideColumnMapper }
    ]
  },
  maxLTV: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Max LTV", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.PERCENT, map: data => defaultPercentField(data, "loanProceedAssumptions[0].maxLTV", 100), Cell: tableSideColumnMapper, decimals: 3 }
    ]
  },
  minDebtYield: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Min Debt Yield", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.PERCENT, map: data => defaultPercentField(data, "loanProceedAssumptions[0].minDebtYield", 100), Cell: tableSideColumnMapper, decimals: 3 }
    ]
  },
  UwRate: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Uw Rate", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.PERCENT, map: data => defaultPercentField(data, "loanProceedAssumptions[0].UwRate", 100), Cell: tableSideColumnMapper, decimals: 3 }
    ]
  }

};

export const generateCashflowRows = data => {
  const rows = {};

  rows.amortizationType = {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Amortization Type", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultField(data, "loanProceedAssumptions[0].amortizationType.name"), Cell: tableSideColumnMapper }
    ]
  };

  rows.amortizationTerms = {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Amortization Terms", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultField(data, "loanProceedAssumptions[0].amortizationTerm"), Cell: tableSideColumnMapper }
    ]
  };

  rows.amortizationRate = {
    isVisible: data => shouldShowFloatingIndex(data),
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Amortization Rate", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.PERCENT, map: data => defaultPercentField(data, "loanProceedAssumptions[0].amortizationRate", 100), Cell: tableSideColumnMapper, decimals: 2 }
    ]
  };

  rows.ioPeriods = {
    isVisible: data => shouldShowIoPeriods(data),
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "I/O Periods", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultField(data, "loanProceedAssumptions[0].interestOnlyPeriods"), Cell: tableSideColumnMapper }
    ]
  };

  rows.dayCount = {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "DayCount", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultField(data, "loanProceedAssumptions[0].dayCount.name"), Cell: tableSideColumnMapper }
    ]
  };

  rows.closingCosts = {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Closing Costs", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.PERCENT, map: data => defaultPercentField(data, "loanProceedAssumptions[0].closingCosts", 100), Cell: tableSideColumnMapper, decimals: 2 }
    ]
  };

  return rows;
};
